import { useEffect } from "react";
import LegalPageLayout from "@/components/LegalPageLayout";

export default function Privacy() {
  useEffect(() => {
    document.title = "Privacy Policy · InPalmo";
  }, []);

  return (
    <LegalPageLayout title="Informativa sulla Privacy" lastUpdate="aggiornata a Febbraio 2026">
      <div
        data-testid="privacy-placeholder-banner"
        className="not-prose p-4 rounded-xl bg-[#FDF6E3] border border-[#F2DEB0] text-sm text-[#8B6518]"
      >
        ⚠️ <strong>Beta chiusa e gratuita.</strong> InPalmo è attualmente in fase di beta test su
        invito. Il Titolare del trattamento è una <strong>persona fisica</strong>: il servizio non
        prevede ancora fatturazione, non esiste alcuna P.IVA collegata. Per ogni richiesta scrivi a{" "}
        <a href="mailto:ciao@inpalmo.it" className="underline font-medium">
          ciao@inpalmo.it
        </a>
        .
      </div>

      <p>
        La presente informativa descrive le modalità con cui <strong>InPalmo</strong> (in seguito,
        &quot;il Servizio&quot;) tratta i dati personali degli utenti, in conformità al Regolamento Generale
        sulla Protezione dei Dati (UE) 2016/679 (&quot;GDPR&quot;) e alla normativa italiana applicabile.
      </p>

      <h2>1. Titolare del trattamento</h2>
      <p>
        Il Titolare del trattamento è <strong>Giuseppe De Masi</strong>, persona fisica residente in
        Italia, che gestisce InPalmo come progetto personale in fase di beta test chiusa e
        gratuita.
        <br />
        Email di contatto per questioni privacy:{" "}
        <a href="mailto:ciao@inpalmo.it">ciao@inpalmo.it</a>.
      </p>

      <h2>2. Tipi di dati raccolti</h2>
      <p>Trattiamo solo i dati strettamente necessari a fornire il Servizio:</p>
      <ul>
        <li>
          <strong>Dati di registrazione</strong> (via Google Sign-In): indirizzo email, nome e
          cognome, immagine del profilo. Non riceviamo né archiviamo la tua password Google.
        </li>
        <li>
          <strong>Dati del negozio inseriti volontariamente</strong>: prodotti, lotti, prezzi,
          scadenze, vendite, fornitori, soglie di giacenza. Sono dati commerciali di proprietà
          esclusiva dell&apos;utente.
        </li>
        <li>
          <strong>Immagini caricate per la scansione AI</strong>: foto di scontrini e DDT vengono
          trasmesse al modello Gemini di Google per estrarre i dati testuali (vedi §6).{" "}
          <strong>Le immagini NON vengono salvate</strong> né sui nostri server né in database:
          sono usate una tantum in memoria e poi scartate.
        </li>
        <li>
          <strong>Codice invito</strong>: durante la beta chiusa memorizziamo il codice invito che
          hai usato per attivare l&apos;account (per motivi di controllo abusi).
        </li>
        <li>
          <strong>Log invii email</strong>: destinatario, oggetto e ora dei riepiloghi serali che
          ti sono stati inviati (per diagnostica e tracciamento consegna).
        </li>
        <li>
          <strong>Dati tecnici di sessione</strong>: un cookie tecnico contenente il token di
          sessione (7 giorni) e, opzionalmente, l&apos;identificatore dello store attivo. Nessun cookie
          di profilazione o di tracciamento è impostato.
        </li>
      </ul>

      <h2>3. Finalità e base giuridica</h2>
      <ul>
        <li>
          <strong>Erogazione del Servizio</strong> (art. 6.1.b GDPR — esecuzione del rapporto):
          gestione magazzino, notifiche scadenze, scansione AI, esportazioni.
        </li>
        <li>
          <strong>Legittimo interesse</strong> (art. 6.1.f GDPR): sicurezza del Servizio,
          prevenzione abusi, miglioramento del prodotto su dati aggregati e anonimi.
        </li>
      </ul>

      <h2>4. Conservazione dei dati</h2>
      <p>
        I dati del tuo negozio restano attivi per tutta la durata dell&apos;utilizzo del Servizio. In
        caso di cancellazione dell&apos;account (vedi §7), tutti i dati vengono <strong>eliminati in
        modo permanente entro 30 giorni</strong> dai backup ciclici. In caso di beta chiusa (fase
        attuale) non esistono obblighi fiscali di conservazione.
      </p>

      <h2>5. Dove vengono conservati</h2>
      <p>
        I dati sono archiviati sull&apos;infrastruttura di <strong>Emergent</strong> (piattaforma di
        hosting) e su <strong>MongoDB</strong> (database). Quando un trasferimento extra-UE è
        inevitabile (es. invio di un&apos;immagine al modello AI di Google, oppure hosting che possa
        avere region USA), avviene esclusivamente verso paesi con decisioni di adeguatezza della
        Commissione Europea o con clausole contrattuali tipo (SCC).
      </p>

      <h2>6. Soggetti terzi (responsabili del trattamento)</h2>
      <p>Per erogare il Servizio ci appoggiamo a un numero ridotto di fornitori affidabili:</p>
      <ul>
        <li>
          <strong>Emergent</strong> — hosting dell&apos;applicazione (frontend + backend).
        </li>
        <li>
          <strong>MongoDB</strong> — database dove sono salvati prodotti, vendite, impostazioni.
        </li>
        <li>
          <strong>Google</strong> — servizio di Sign-In per l&apos;autenticazione e modello AI
          &quot;Gemini&quot; per la scansione di scontrini/DDT. Le immagini sono trasmesse solo al momento
          della richiesta e non usate per addestramento (secondo i termini di Google Cloud AI).
        </li>
        <li>
          <strong>Resend</strong> — invio di notifiche email transazionali (riepilogo serale delle
          vendite, avvisi scadenze) dal dominio <em>inpalmo.it</em>.
        </li>
      </ul>
      <p>
        Ciascun fornitore è nominato Responsabile del trattamento ai sensi dell&apos;art. 28 GDPR e
        applica standard di sicurezza adeguati. <strong>Nessun servizio di analytics, tracking
        pubblicitario o profilazione</strong> è integrato in InPalmo.
      </p>

      <h2>7. I tuoi diritti</h2>
      <p>In qualsiasi momento puoi esercitare i diritti previsti dagli artt. 15-22 GDPR:</p>
      <ul>
        <li>
          <strong>Accesso e portabilità</strong>: dalla pagina <em>Impostazioni → Account</em> puoi
          scaricare un export completo dei tuoi dati in formato JSON (profilo, prodotti, vendite,
          fornitori, impostazioni, log email, learnings AI). Prodotti e vendite sono inoltre
          esportabili in CSV/Excel.
        </li>
        <li>
          <strong>Rettifica</strong>: puoi modificare o correggere ogni dato direttamente
          dall&apos;app.
        </li>
        <li>
          <strong>Cancellazione (oblio)</strong>: dalla pagina <em>Impostazioni → Account</em> puoi
          eliminare il tuo account e tutti i dati associati in modo permanente. L&apos;azione include:
          profilo, store posseduti con tutti i loro prodotti/vendite/fornitori/impostazioni, log
          email, learnings AI, sessioni attive ed eventuali registrazioni Google pendenti per la
          stessa email. L&apos;invio automatico serale delle 21:00 viene disattivato di conseguenza.
        </li>
        <li>
          <strong>Limitazione del trattamento</strong> e <strong>opposizione</strong>: scrivici a{" "}
          <a href="mailto:ciao@inpalmo.it">ciao@inpalmo.it</a>.
        </li>
        <li>
          <strong>Reclamo</strong>: hai diritto di proporre reclamo all&apos;Autorità Garante per la
          Protezione dei Dati Personali (<a href="https://www.garanteprivacy.it">garanteprivacy.it</a>).
        </li>
      </ul>

      <h2>8. Cookie</h2>
      <p>
        InPalmo utilizza esclusivamente <strong>cookie tecnici essenziali</strong> al
        funzionamento del Servizio: il cookie <code>session_token</code> (autenticazione, 7 giorni)
        e opzionalmente <code>active_store_id</code> (store attivo). <strong>Non</strong>{" "}
        utilizziamo cookie di profilazione, marketing o di analitica di terze parti. Per questa
        ragione, ai sensi dell&apos;art. 122 del Codice Privacy, non è richiesto un consenso espresso
        prima del loro utilizzo: il banner informativo che vedi alla prima visita ha finalità di
        trasparenza.
      </p>

      <h2>9. Sicurezza</h2>
      <p>
        Adottiamo misure tecniche e organizzative adeguate per proteggere i dati: crittografia in
        transito (TLS 1.3), accessi limitati al Titolare, separazione logica dei dati tra utenti
        (multi-tenancy per store), sessioni con scadenza automatica.
      </p>

      <h2>10. Minori</h2>
      <p>
        Il Servizio non è destinato a soggetti minori di 16 anni. Se vieni a conoscenza che un
        minore ha registrato un account, ti invitiamo a segnalarcelo all&apos;indirizzo{" "}
        <a href="mailto:ciao@inpalmo.it">ciao@inpalmo.it</a>: provvederemo alla
        cancellazione.
      </p>

      <h2>11. Modifiche all&apos;informativa</h2>
      <p>
        Questa informativa può essere aggiornata: in caso di modifiche sostanziali ti avviseremo
        via email e/o tramite avviso in-app prima dell&apos;entrata in vigore.
      </p>
    </LegalPageLayout>
  );
}
